<ng-template #login>
  <!-- <header [logoUrl]="logoUrl"></header> -->
  <div class="d-flex flex-column flex-column-fluid p-10 pb-lg-10 login-wrapper">
    <div class="w-md-500px bg-white rounded shadow-sm p-7 p-lg-7 login-body">
      <div class="d-flex justify-content-between align-items-start">
        <div class="flex-grow-1 d-flex justify-content-center">
          <logo [logoUrlsToTry]="possibleLogoUrls"></logo>
        </div>
        <language-switcher *ngIf="anonymousPortalSettings.languageToggleEnabled$ | async"
                           [notice]="anonymousPortalSettings.languageToggleNotice$ | async"></language-switcher>
      </div>

      <form class="form w-100" #loginForm="ngForm" novalidate id="loginForm" name="loginForm">
        <ng-container *transloco="let t">
        <div class="text-center my-4">
          <h2 class="text-dark mb-2">{{ t('auth.login.signIn') }}</h2>
          @if (canCreateAccount) {
            <div class="text-gray-400 fw-bold fs-5">{{ t('auth.login.newHere') }}
              <a (click)="onCreateAccountClicked()" class="link-primary fw-bolder">{{ t('auth.login.createAccount') }}</a>
            </div>
          }
        </div>
        @if (errorMessage) {
          <div class="alert alert-danger d-flex align-items-center p-5 mb-5">
            <span class="svg-icon svg-icon-2hx svg-icon-danger me-3">
              <duotone-shield-check-svg-icon></duotone-shield-check-svg-icon>
            </span>
            <div class="d-flex flex-column">
              <span>{{errorMessage}}</span>
            </div>
          </div>
        }
        <ngb-carousel #slider [showNavigationArrows]="false" [showNavigationIndicators]="false"
          [interval]="0" [keyboard]="false"
          (slide)="currentSlideId = $event.current"
          (slid)="onCarouselTransitionComplete($event)">
          <ng-template ngbSlide id="askForEmail">
            <div class="login-slide-pane">
              @if (spinnerVisible) {
                <ng-container *ngTemplateOutlet="loginSkeleton"></ng-container>
              } @else if (!mfaCodeEntryRequired && !mfaSetupRequired) {
                <div class="fv-row mb-10 mt-3">
                  <label class="form-label fs-6 fw-bolder text-dark">{{ t('auth.login.enterEmail') }}</label>
                  <input type="text" autocomplete="off" autocapitalize="none" trim
                    class="form-control form-control-lg form-control-solid"
                    name="username" id="login-username"
                    [placeholder]="t('auth.login.enterUsername')" #userName="ngModel"
                    [ngClass]="{'is-invalid' : userName && userName.touched && userName.invalid}"
                    (keyup.enter)="onLoginClicked()"
                    [(ngModel)]="loginRequest.username" required email>
                  <div class="invalid-feedback">{{ t('auth.login.invalidEmail') }}</div>
                </div>
              }
            </div>
          </ng-template>
          <ng-template ngbSlide id="companySelection">
            <div class="login-slide-pane p-3">
              @if (spinnerVisible) {
                <ng-container *ngTemplateOutlet="loginSkeleton"></ng-container>
              } @else {
                <div class="center mt-4">
                  <h4 class="card-title mb-4">{{ t('auth.login.multipleCompanies') }}</h4>
                  <p class="text-muted mb-4">{{ t('auth.login.selectCompany') }}</p>
                  <div class="mt-2 mb-10">
                    <select class="form-select" name="company" id="company" [(ngModel)]="loginRequest.userCompanyGuid"
                      (ngModelChange)="onAvailableCompanyPickedForLogin()">
                      <option [ngValue]="null">{{ t('common.selectOne') }}</option>
                      @for (companies of availableCompanies | groupBy: 'companyGuid'; track companies.key) {
                        <optgroup label="{{companies.value[0].companyName}}">
                          @for (company of companies.value; track company.userCompanyGuid; let i = $index) {
                            <option [ngValue]="company.userCompanyGuid">
                              {{company.userType}}
                            </option>
                          }
                        </optgroup>
                      }
                    </select>
                  </div>
                </div>
              }
            </div>
          </ng-template>
          <ng-template ngbSlide id="askForPassword">
            <div class="login-slide-pane">
              @if (spinnerVisible) {
                <ng-container *ngTemplateOutlet="loginSkeleton"></ng-container>
              } @else if (!mfaCodeEntryRequired && !mfaSetupRequired && passwordRequired) {
                <div class="fv-row mb-10 mt-3">
                  <div class="d-flex justify-content-between mb-2">
                    <label class="form-label fw-bolder text-dark fs-6 mb-0">{{ t('auth.login.enterPassword') }}</label>
                    <a (click)="onForgotPasswordClicked()" class="link-primary fs-6 fw-bolder">{{ t('auth.login.forgotPassword') }}</a>
                  </div>
                  <input class="form-control form-control-lg form-control-solid" type="password" name="password" required
                    [ngClass]="{'is-invalid' : userPassword && userPassword.touched && userPassword.invalid}"
                    (keyup.enter)="onLoginClicked()"
                    autocomplete="off" [(ngModel)]="loginRequest.password"
                    #userPassword="ngModel" />
                  <div class="invalid-feedback">{{ t('auth.login.enterPasswordPlaceholder') }}</div>
                  <div class="mt-3">
                    <a (click)="onCancelLoginClicked()" class="link-primary fs-6 fw-bolder">{{ t('auth.login.useDifferentEmail') }}</a>
                  </div>
                </div>
              }
            </div>
          </ng-template>
          <ng-template ngbSlide id="twoFactorCodeEntry">
            <div class="login-slide-pane p-3">
              @if (spinnerVisible) {
                <ng-container *ngTemplateOutlet="loginSkeleton"></ng-container>
              } @else {
                <div class="center mt-4">
                  <h4 class="card-title mb-2">{{ t('auth.login.mfa.confirmTitle') }}</h4>
                  <p class="text-muted mb-2">{{ t('auth.login.mfa.enterCode') }}</p>
                  <p class="text-muted mb-2">
                    {{ t('auth.login.mfa.needNewCode') }}
                    <a (click)="onSendCodeClicked()"> {{ t('auth.login.mfa.resendCode') }} </a>
                  </p>
                  <div class="mt-2">
                    <input type="text" autocomplete="off" class="form-control" name="twoFactorCode"
                      id="twoFactorCode" [placeholder]="t('auth.login.mfa.enterCodePlaceholder')" #twoFactorCode="ngModel"
                      [ngClass]="{'is-invalid' : twoFactorCode && twoFactorCode.touched && twoFactorCode.invalid}"
                      [(ngModel)]="loginRequest.twoFactorCode" (keyup.enter)="onLoginClicked()" autofocus="autofocus"
                      #twoFactorCodeInput>
                    <div class="invalid-feedback">{{ t('auth.login.mfa.incorrectCode') }}</div>
                  </div>
                </div>
              }
            </div>
          </ng-template>
          <ng-template ngbSlide id="mfaSetup">
            <!-- mfaSetup deliberately does NOT swap to the skeleton during loading.
                 Its two sub-stages (enter phone → confirm code) call APIs that
                 don't always change slides, so preserving the user's entered
                 values during the round-trip is the better UX. The action buttons
                 below collapse to a "Please wait..." spinner instead. -->
            <div class="login-slide-pane p-3">
              <form class="form-horizontal auth-form" #mfaSetupForm="ngForm" novalidate id="mfaSetupForm"
                name="mfaSetupForm">
                <div class="center mt-4">
                  <h4 class="card-title mb-2">{{ t('auth.login.mfa.setupTitle') }}</h4>
                  @if (!needToConfirmPhone) {
                    <p class="text-muted mb-2">{{ t('auth.login.mfa.enterPhone') }}</p>
                    <div class="mt-2">
                      <div class="form-group mb-3 d-flex">
                        <div class="flex-grow-1">
                          <label class="form-label">{{ t('auth.login.mfa.countryCode') }}</label>
                          <select class="form-select" name="areaCode" [(ngModel)]="areaCode" [disabled]="spinnerVisible" required>
                            @for (country of countries; track country.value) {
                              <option [value]="country.value">{{'(' + country.areaCode + ')' + " " + country.name}}
                              </option>
                            }
                          </select>
                        </div>
                        <div class="ms-2">
                          <label class="form-label">{{ t('auth.login.mfa.phoneNumber') }}</label>
                          <input name="phoneNumber" class="form-control" [(ngModel)]="phone" [disabled]="spinnerVisible"
                            [mask]="'(000) 000-0000'" [placeholder]="'(###) ###-####'" type="text">
                        </div>
                      </div>
                      <div class="d-flex bd-highlight mt-3">
                        @if (spinnerVisible) {
                          <ng-container *ngTemplateOutlet="mfaPleaseWaitButton"></ng-container>
                        } @else {
                          <button type="button" class="btn btn-white"
                            (click)="onCancelLoginClicked()">{{ t('common.cancel') }}</button>
                          <button type="button" (click)="onSaveNumberClicked()" [disabled]="!areaCode || !phone"
                            class="btn btn-primary ms-auto">{{ t('auth.login.mfa.saveNumber') }}</button>
                        }
                      </div>
                    </div>
                  } @else {
                    <p class="text-muted mb-2">{{ t('auth.login.mfa.enterCode') }}</p>
                    <div class="mt-2 d-flex">
                      <input type="text" autocomplete="off" class="form-control me-1" name="verificationCode"
                        id="verificationCode" [disabled]="spinnerVisible" [placeholder]="t('auth.login.mfa.enterCodePlaceholder')"
                        #verificationCodeValue="ngModel"
                        [ngClass]="{'is-invalid' : verificationCodeValue && verificationCodeValue.touched && verificationCodeValue.invalid}"
                        [(ngModel)]="verificationCode" (keyup.enter)="onLoginClicked()" autofocus="autofocus"
                        #verificationCodeInput>
                      <div class="invalid-feedback">{{ t('auth.login.mfa.incorrectCode') }}</div>
                      <button type="button" style="width: 250px" [disabled]="spinnerVisible"
                        (click)="onChangeNumberClicked()"
                        class="btn btn-primary ms-auto">{{ t('auth.login.mfa.changeNumber') }}</button>
                    </div>
                    <div class="d-flex bd-highlight mt-3">
                      @if (spinnerVisible) {
                        <ng-container *ngTemplateOutlet="mfaPleaseWaitButton"></ng-container>
                      } @else {
                        <button type="button" class="btn btn-white"
                          (click)="onCancelLoginClicked()">{{ t('common.cancel') }}</button>
                        <button type="button" (click)="onConfirmPhoneClicked()" [disabled]="!verificationCode"
                          class="btn btn-primary ms-auto">{{ t('auth.login.verify') }}</button>
                      }
                    </div>
                  }
                </div>
              </form>
            </div>
          </ng-template>
          <ng-template ngbSlide id="roleSelection">
            <div class="login-slide-pane p-3">
              @if (spinnerVisible) {
                <ng-container *ngTemplateOutlet="loginSkeleton"></ng-container>
              } @else {
                <div class="center mt-4">
                  <h4 class="card-title mb-4">{{ t('auth.login.multipleRoles') }}</h4>
                  <p class="text-muted mb-4">{{ t('auth.login.selectRole') }}</p>
                  <div class="mt-2 mb-10">
                    <select class="form-select" name="role" id="role" [(ngModel)]="userScope">
                      <option [value]="-1">{{ t('common.selectOne') }}</option>
                      @for (role of availableRoles; track role) {
                        <option value="{{role}}">
                          {{role}}
                        </option>
                      }
                    </select>
                  </div>
                </div>
              }
            </div>
          </ng-template>
        </ngb-carousel>
        @if (currentSlideId !== 'mfaSetup') {
          <div class="login-action-bar mt-3 mb-5">
            @if (spinnerVisible) {
              <button class="btn btn-lg btn-primary w-100" type="button" disabled>
                <span class="indicator-label">{{ t('common.pleaseWait') }}</span>
                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
              </button>
            } @else if (currentSlideId === 'companySelection') {
              <div class="d-flex w-100">
                <button type="button" class="btn btn-lg btn-white"
                        (click)="onCancelLoginClicked()">{{ t('common.cancel') }}</button>
              </div>
            } @else if (currentSlideId === 'twoFactorCodeEntry') {
              <div class="d-flex w-100">
                <button type="button" class="btn btn-lg btn-white"
                        (click)="onCancelLoginClicked()">{{ t('common.cancel') }}</button>
                <button type="button" class="btn btn-lg btn-primary ms-auto"
                        [disabled]="!loginRequest.twoFactorCode"
                        (click)="onLoginClicked()">{{ t('auth.login.verify') }}</button>
              </div>
            } @else if (currentSlideId === 'roleSelection') {
              <div class="d-flex w-100">
                <button type="button" class="btn btn-lg btn-white"
                        (click)="onCancelLoginClicked()">{{ t('common.cancel') }}</button>
                <button type="button" class="btn btn-lg btn-primary ms-auto"
                        (click)="onLoginClicked()">{{ t('auth.login.continueBtn') }}</button>
              </div>
            } @else {
              <button type="button" class="btn btn-lg btn-primary w-100"
                      (click)="onLoginClicked()">{{ t('auth.login.continueBtn') }}</button>
            }
          </div>
        }

        <!-- Shared skeleton: 4-line shimmer used by every slide while spinnerVisible. -->
        <ng-template #loginSkeleton>
          <div class="login-skeleton">
            <div class="login-skeleton__line login-skeleton__line--title"></div>
            <div class="login-skeleton__line login-skeleton__line--subtitle"></div>
            <div class="login-skeleton__line login-skeleton__line--input"></div>
            <div class="login-skeleton__line login-skeleton__line--helper"></div>
          </div>
        </ng-template>

        <!-- Shared "Please wait..." button used by mfaSetup's two action rows. -->
        <ng-template #mfaPleaseWaitButton>
          <button class="btn btn-primary waves-effect waves-light ms-auto" type="button" disabled>
            <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            {{ t('common.pleaseWait') }}
          </button>
        </ng-template>
        </ng-container>
      </form>
    </div>
    <div class="overlay-layer rounded bg-primary-o-20">
      <div class="spinner spinner-primary"></div>
    </div>
  </div>
  <div class="d-flex flex-column justify-content-center align-items-center">
    <div class="login-footer">
      <img src="/assets/images/loda-logo.svg" height="30" alt="Lodasoft">
    </div>
  </div>

</ng-template>

<user-account-template [contentTemplate]="login"></user-account-template>
